/* tslint:disable */
import icon from 'vue-svgicon'
icon.register({
  'rating-1': {
    width: 44,
    height: 44,
    viewBox: '0 0 44 44',
    data: `<defs><clipPath id="svgicon_rating-1_a"><path pid="0" d="M0 0h44v44H0z"/></clipPath></defs><g clip-path="url(#svgicon_rating-1_a)"><g transform="translate(.037 17.296)"><circle pid="1" cx="5" cy="5" r="5" transform="translate(-.037 -.296)" _fill="currentColor"/><g transform="translate(16.963 -.296)" _fill="none" _stroke="currentColor" stroke-miterlimit="10" stroke-width="1.5"><circle pid="2" cx="5" cy="5" r="5" _stroke="none"/><circle pid="3" cx="5" cy="5" r="4.25"/></g><g transform="translate(33.963 -.296)" _fill="none" _stroke="currentColor" stroke-miterlimit="10" stroke-width="1.5"><circle pid="4" cx="5" cy="5" r="5" _stroke="none"/><circle pid="5" cx="5" cy="5" r="4.25"/></g></g></g>`
  }
})
/* tslint:enable */
